/* AI Shop Product Section - Image Gallery & Variant Selection JavaScript */

// ═══════════════════════════════════════════════════════════════
// IMAGE GALLERY SECTION 1
// ═══════════════════════════════════════════════════════════════
document.addEventListener("DOMContentLoaded", function () {
  const mainImage1 = document.getElementById("duplicate-main-image-1");
  const thumbnails1 = document.querySelectorAll("#image-gallery-duplicate-1 .duplicate-thumbnails img");
  const thumbnailsContainer1 = document.querySelector("#image-gallery-duplicate-1 .duplicate-thumbnails");
  
  if (!mainImage1 || !thumbnails1.length) return; // Exit if gallery 1 doesn't exist
  
  const thumbnailWidth1 = window.innerWidth > 768 ? 100 : 90;
  const visibleThumbnails1 = 5;
  const totalThumbnails1 = thumbnails1.length;
  let currentIndex1 = 0;
  let thumbnailOffset1 = 0;

  // Array of image sources for Section 1
  const images1 = [
    "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3-60ct.jpg?v=1758159288",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_30_Day_Supply.png?v=1732605080",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page02.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page02.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page03.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page03.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page04.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page04.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page05.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page05.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page06.jpg?v=1744841342",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page07.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page07.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page08.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page08.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page09.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon_NAD3_60ct_Spanish_page09.jpg?v=1737068608"
  ];

  // Update gallery function
  function updateGallery1(index) {
    currentIndex1 = (index + images1.length) % images1.length;
    const previousImage1 = mainImage1;

    previousImage1.classList.add("image-exit");

    setTimeout(() => {
      previousImage1.classList.remove("image-exit");
      const tempImage1 = new Image();
      tempImage1.src = images1[currentIndex1];
      tempImage1.onload = () => {
        mainImage1.classList.add("image-enter");
        mainImage1.src = images1[currentIndex1];
        setTimeout(() => {
          mainImage1.classList.add("show");
          mainImage1.classList.remove("image-enter");
        }, 50);
      };
    }, 500);

    thumbnails1.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === currentIndex1);
    });

    adjustThumbnails1();
  }

  // Adjust thumbnails view
  function adjustThumbnails1() {
    if (currentIndex1 >= visibleThumbnails1 - 1 && currentIndex1 < totalThumbnails1) {
      thumbnailOffset1 = currentIndex1 - (visibleThumbnails1 - 2);
      if (thumbnailOffset1 < 0) thumbnailOffset1 = 0;
      if (thumbnailOffset1 > totalThumbnails1 - visibleThumbnails1) {
        thumbnailOffset1 = totalThumbnails1 - visibleThumbnails1;
      }
      thumbnailsContainer1.style.transform = `translateX(-${thumbnailOffset1 * thumbnailWidth1}px)`;
    } else {
      thumbnailsContainer1.style.transform = `translateX(0)`;
    }
  }

  // Thumbnail click events
  thumbnails1.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      if (index !== currentIndex1) {
        updateGallery1(index);
      }
    });
  });

  // Swipe functionality
  let startX1 = 0;
  let isSwiping1 = false;

  // Touch events
  mainImage1.addEventListener("touchstart", function(e) {
    startX1 = e.touches[0].clientX;
    isSwiping1 = true;
  });

  mainImage1.addEventListener("touchmove", function(e) {
    if (!isSwiping1) return;
    const currentX = e.touches[0].clientX;
    const diff = startX1 - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        updateGallery1(currentIndex1 + 1);
      } else {
        updateGallery1(currentIndex1 - 1);
      }
      isSwiping1 = false;
    }
  });

  mainImage1.addEventListener("touchend", function(e) {
    isSwiping1 = false;
  });

  // Mouse events
  mainImage1.addEventListener("mousedown", function(e) {
    startX1 = e.clientX;
    isSwiping1 = true;
  });

  mainImage1.addEventListener("mousemove", function(e) {
    if (!isSwiping1) return;
    const currentX = e.clientX;
    const diff = startX1 - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        updateGallery1(currentIndex1 + 1);
      } else {
        updateGallery1(currentIndex1 - 1);
      }
      isSwiping1 = false;
    }
  });

  mainImage1.addEventListener("mouseup", function(e) {
    isSwiping1 = false;
  });

  mainImage1.addEventListener("mouseleave", function(e) {
    isSwiping1 = false;
  });

  // Initialize gallery
  updateGallery1(currentIndex1);
});

// ═══════════════════════════════════════════════════════════════
// IMAGE GALLERY SECTION 2
// ═══════════════════════════════════════════════════════════════
document.addEventListener("DOMContentLoaded", function () {
  const mainImage2 = document.getElementById("duplicate-main-image-2");
  const thumbnails2 = document.querySelectorAll("#image-gallery-duplicate-2 .duplicate-thumbnails img");
  const thumbnailsContainer2 = document.querySelector("#image-gallery-duplicate-2 .duplicate-thumbnails");
  
  if (!mainImage2 || !thumbnails2.length) return; // Exit if gallery 2 doesn't exist
  
  const thumbnailWidth2 = window.innerWidth > 768 ? 100 : 90;
  const visibleThumbnails2 = 5;
  const totalThumbnails2 = thumbnails2.length;
  let currentIndex2 = 0;
  let thumbnailOffset2 = 0;

  // Array of image sources for Section 2
  const images2 = [
    "https://cdn.shopify.com/s/files/1/2443/2395/files/NAD3_30_Day_Supply.png?v=1732605080",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page02.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page02.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page03.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page03.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page04.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page04.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page05.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page05.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page06.jpg?v=1744841342",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page07.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page07.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page08.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page08.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_English_page09.jpg?v=1744842075",
    "https://cdn.shopify.com/s/files/1/2443/2395/files/Amazon1x1_NAD3_60ct_Spanish_page09.jpg?v=1744842075"
  ];

  // Update gallery function
  function updateGallery2(index) {
    currentIndex2 = (index + images2.length) % images2.length;
    const previousImage2 = mainImage2;

    previousImage2.classList.add("image-exit");

    setTimeout(() => {
      previousImage2.classList.remove("image-exit");
      const tempImage2 = new Image();
      tempImage2.src = images2[currentIndex2];
      tempImage2.onload = () => {
        mainImage2.classList.add("image-enter");
        mainImage2.src = images2[currentIndex2];
        setTimeout(() => {
          mainImage2.classList.add("show");
          mainImage2.classList.remove("image-enter");
        }, 50);
      };
    }, 500);

    thumbnails2.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === currentIndex2);
    });

    adjustThumbnails2();
  }

  // Adjust thumbnails view
  function adjustThumbnails2() {
    if (currentIndex2 >= visibleThumbnails2 - 1 && currentIndex2 < totalThumbnails2) {
      thumbnailOffset2 = currentIndex2 - (visibleThumbnails2 - 2);
      if (thumbnailOffset2 < 0) thumbnailOffset2 = 0;
      if (thumbnailOffset2 > totalThumbnails2 - visibleThumbnails2) {
        thumbnailOffset2 = totalThumbnails2 - visibleThumbnails2;
      }
      thumbnailsContainer2.style.transform = `translateX(-${thumbnailOffset2 * thumbnailWidth2}px)`;
    } else {
      thumbnailsContainer2.style.transform = `translateX(0)`;
    }
  }

  // Thumbnail click events
  thumbnails2.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      if (index !== currentIndex2) {
        updateGallery2(index);
      }
    });
  });

  // Swipe functionality
  let startX2 = 0;
  let isSwiping2 = false;

  // Touch events
  mainImage2.addEventListener("touchstart", function(e) {
    startX2 = e.touches[0].clientX;
    isSwiping2 = true;
  });

  mainImage2.addEventListener("touchmove", function(e) {
    if (!isSwiping2) return;
    const currentX = e.touches[0].clientX;
    const diff = startX2 - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        updateGallery2(currentIndex2 + 1);
      } else {
        updateGallery2(currentIndex2 - 1);
      }
      isSwiping2 = false;
    }
  });

  mainImage2.addEventListener("touchend", function(e) {
    isSwiping2 = false;
  });

  // Mouse events
  mainImage2.addEventListener("mousedown", function(e) {
    startX2 = e.clientX;
    isSwiping2 = true;
  });

  mainImage2.addEventListener("mousemove", function(e) {
    if (!isSwiping2) return;
    const currentX = e.clientX;
    const diff = startX2 - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        updateGallery2(currentIndex2 + 1);
      } else {
        updateGallery2(currentIndex2 - 1);
      }
      isSwiping2 = false;
    }
  });

  mainImage2.addEventListener("mouseup", function(e) {
    isSwiping2 = false;
  });

  mainImage2.addEventListener("mouseleave", function(e) {
    isSwiping2 = false;
  });

  // Initialize gallery
  updateGallery2(currentIndex2);
});

// ═══════════════════════════════════════════════════════════════
// VARIANT SELECTION & ADD TO CART
// ═══════════════════════════════════════════════════════════════
document.addEventListener('DOMContentLoaded', () => {
  // ────────────────────────────────────────────────────────────
  // SECTION 1
  // ────────────────────────────────────────────────────────────
  const variantButtons1 = document.querySelectorAll('#variant-buttons-1 .variant-button');
  const addToCartBtn1 = document.getElementById('add-to-cart-btn-1');
  let selectedVariantId1 = null;

  // Select Variant 2 on page load for Section 1
  const defaultSelectedButton1 = document.querySelector('#variant-buttons-1 .variant-button[data-variant-id="21174522708052"]');
  if (defaultSelectedButton1) {
    defaultSelectedButton1.classList.add('active');
    selectedVariantId1 = defaultSelectedButton1.dataset.variantId;
  }
    
  variantButtons1.forEach(button => {
    button.addEventListener('click', () => {
      // Reset selection
      variantButtons1.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      selectedVariantId1 = button.dataset.variantId;

      const defaultCallout = document.getElementById('default-free-items-callout-1');
      if (defaultCallout) defaultCallout.style.display = 'none';

      // Update pricing and text based on selected variant
      const saveBanner1 = document.getElementById('save-banner-1');
      const comparePrice1 = document.getElementById('compare-price-1');
      const priceInteger1 = document.getElementById('price-integer-1');
      const priceFraction1 = document.getElementById('price-fraction-1');
      const calloutText1 = document.getElementById('callout-text-1');

      if (selectedVariantId1 === "21174522708052") { // Variant 2
        saveBanner1.textContent = "Save 25% Instantly";
        comparePrice1.textContent = "$158.97";
        priceInteger1.textContent = "119";
        priceFraction1.textContent = ".00";
        calloutText1.textContent = "$46.99 in FREE Value included with this order!";
      } else if (selectedVariantId1 === "39922146705545") { // Variant 3
        saveBanner1.textContent = "Save 28% Instantly";
        comparePrice1.textContent = "$211.96";
        priceInteger1.textContent = "156";
        priceFraction1.textContent = ".00";
        calloutText1.textContent = "Includes a FREE GIFT valued at $59.98";
      } else {
        // Reset to default for Variant 1
        saveBanner1.textContent = "Save 20% Instantly";
        comparePrice1.textContent = "$52.99";
        priceInteger1.textContent = "42";
        priceFraction1.textContent = ".00";
        calloutText1.textContent = "$40 in FREE Value included with this order!";
      }

      // Update the free items callout
      if (typeof updateCalloutImage1 === 'function') {
        updateCalloutImage1(selectedVariantId1);
      }
    });
  });

  // Add to cart for Section 1
  if (addToCartBtn1) {
    addToCartBtn1.addEventListener('click', () => {
      if (selectedVariantId1) {
        fetch(`/cart/add.js?quantity=1&id=${selectedVariantId1}`, {
          method: 'POST',
        })
        .then(response => response.json())
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(error => console.error('Error:', error));
      } else {
        alert('Please select a variant!');
      }
    });
  }

  // ────────────────────────────────────────────────────────────
  // SECTION 2
  // ────────────────────────────────────────────────────────────
  const variantButtons2 = document.querySelectorAll('#variant-buttons-2 .variant-button-2');
  const addToCartBtn2 = document.getElementById('add-to-cart-btn-2');
  let selectedVariantId2 = null;

  // Select Variant 2 on page load for Section 2
  const defaultSelectedButton2 = document.querySelector('#variant-buttons-2 .variant-button-2[data-variant-id="21174522708052-2"]');
  if (defaultSelectedButton2) {
    defaultSelectedButton2.classList.add('active');
    selectedVariantId2 = defaultSelectedButton2.dataset.variantId;
  }
    
  variantButtons2.forEach(button => {
    button.addEventListener('click', () => {
      // Reset selection
      variantButtons2.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');
      selectedVariantId2 = button.dataset.variantId;

      const defaultCallout2 = document.getElementById('default-free-items-callout-2');
      if (defaultCallout2) defaultCallout2.style.display = 'none';

      // Update pricing and text based on selected variant
      const saveBanner2 = document.getElementById('save-banner-2');
      const comparePrice2 = document.getElementById('compare-price-2');
      const priceInteger2 = document.getElementById('price-integer-2');
      const priceFraction2 = document.getElementById('price-fraction-2');
      const calloutText2 = document.getElementById('callout-text-2');

      if (selectedVariantId2 === "21174522708052-2") { // Variant 2
        saveBanner2.textContent = "Save 25% Instantly";
        comparePrice2.textContent = "$158.97";
        priceInteger2.textContent = "119";
        priceFraction2.textContent = ".00";
        calloutText2.textContent = "$46.99 in FREE Value included with this order!";
      } else if (selectedVariantId2 === "39922146705545-2") { // Variant 3
        saveBanner2.textContent = "Save 28% Instantly";
        comparePrice2.textContent = "$211.96";
        priceInteger2.textContent = "156";
        priceFraction2.textContent = ".00";
        calloutText2.textContent = "Includes a FREE GIFT valued at $59.98";
      } else {
        // Reset to default for Variant 1
        saveBanner2.textContent = "Save 20% Instantly";
        comparePrice2.textContent = "$52.99";
        priceInteger2.textContent = "42";
        priceFraction2.textContent = ".00";
        calloutText2.textContent = "$40 in FREE Value included with this order!";
      }

      // Update the free items callout
      if (typeof updateCalloutImage2 === 'function') {
        updateCalloutImage2(selectedVariantId2);
      }
    });
  });

  // Add to cart for Section 2
  if (addToCartBtn2) {
    addToCartBtn2.addEventListener('click', () => {
      if (selectedVariantId2) {
        fetch(`/cart/add.js?quantity=1&id=${selectedVariantId2}`, {
          method: 'POST',
        })
        .then(response => response.json())
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(error => console.error('Error:', error));
      } else {
        alert('Please select a variant!');
      }
    });
  }

  // Benefits Dropdown Functionality - wrapped in function for reusability
  function initDropdowns() {
    const dropdownHeaders = document.querySelectorAll('.p-herbs-dropdown-header');
    if (!dropdownHeaders.length) return;
    
    dropdownHeaders.forEach(function (header) {
      // Remove existing listeners by cloning
      const newHeader = header.cloneNode(true);
      header.parentNode.replaceChild(newHeader, header);
      
      newHeader.addEventListener('click', function () {
        const dropdown = this.parentElement;
        const isActive = dropdown.classList.contains('active');

        // Close all other dropdowns
        document.querySelectorAll('.p-herbs-dropdown').forEach(function (d) {
          d.classList.remove('active');
          const toggle = d.querySelector('.p-herbs-dropdown-toggle');
          const content = d.querySelector('.p-herbs-dropdown-content');
          if (toggle) toggle.style.transform = 'rotate(0deg)';
          if (content) content.style.display = 'none';

          const icon = d.querySelector('.p-herbs-dropdown-icon');
          if (icon) {
            icon.src = 'https://cdn.shopify.com/s/files/1/2443/2395/files/Icon_-_HPN_Dark_Blue_Logo_CENTER.png?v=1734420637';
          }
        });

        // Toggle the current dropdown
        if (isActive) {
          dropdown.classList.remove('active');
          const toggle = dropdown.querySelector('.p-herbs-dropdown-toggle');
          const content = dropdown.querySelector('.p-herbs-dropdown-content');
          if (toggle) toggle.style.transform = 'rotate(0deg)';
          if (content) content.style.display = 'none';

          const icon = dropdown.querySelector('.p-herbs-dropdown-icon');
          if (icon) {
            icon.src = 'https://cdn.shopify.com/s/files/1/2443/2395/files/Icon_-_HPN_Dark_Blue_Logo_CENTER.png?v=1734420637';
          }
        } else {
          dropdown.classList.add('active');
          const toggle = dropdown.querySelector('.p-herbs-dropdown-toggle');
          const content = dropdown.querySelector('.p-herbs-dropdown-content');
          if (toggle) toggle.style.transform = 'rotate(180deg)';
          if (content) content.style.display = 'block';

          const icon = dropdown.querySelector('.p-herbs-dropdown-icon');
          if (icon) {
            icon.src = 'https://cdn.shopify.com/s/files/1/2443/2395/files/Icon_-_HPN_Dark_Blue_Logo.png?v=1724444940';
          }
        }
      });
    });
  }
  
  // Initialize dropdowns
  initDropdowns();
});

// Also initialize dropdowns when DOM is ready (backup for deferred scripts)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const dropdownHeaders = document.querySelectorAll('.p-herbs-dropdown-header');
      if (dropdownHeaders.length) {
        dropdownHeaders.forEach(function (header) {
          if (!header.hasAttribute('data-dropdown-init')) {
            header.setAttribute('data-dropdown-init', 'true');
            header.addEventListener('click', function () {
              const dropdown = this.parentElement;
              const isActive = dropdown.classList.contains('active');

              document.querySelectorAll('.p-herbs-dropdown').forEach(function (d) {
                d.classList.remove('active');
                const toggle = d.querySelector('.p-herbs-dropdown-toggle');
                const content = d.querySelector('.p-herbs-dropdown-content');
                if (toggle) toggle.style.transform = 'rotate(0deg)';
                if (content) content.style.display = 'none';
              });

              if (!isActive) {
                dropdown.classList.add('active');
                const toggle = dropdown.querySelector('.p-herbs-dropdown-toggle');
                const content = dropdown.querySelector('.p-herbs-dropdown-content');
                if (toggle) toggle.style.transform = 'rotate(180deg)';
                if (content) content.style.display = 'block';
              }
            });
          }
        });
      }
    }, 100);
  });
}

